const config = {
    hiddenClass: 'hidden',
    hiddenStickyClass: 'compare--srp--mobile--hidden',
    disabledClass: 'btn--disabled',
    btnHref: '/compare',
    maxPerPage: 12
};

export default class CompareWidget {
    constructor(widgetEl) {
        this.widget = widgetEl;
        this.itemTemplate = this.widget.find('#widget-item-template');
        this.pageTemplate = this.widget.find('#widget-page-template');
        this.page = 0;
    }

    rebuild() {
        let storageData = this.getFromStorage();
        this.renderItems(storageData);
        this.setPagination(storageData);

        $(document).trigger('compare:widget:rebuild');

        return false;
    }

    renderItems(storageData) {
        let list = this.widget.find('.media-list'),
            emptyImage = this.widget.find('.media-empty__image'),
            emptyText = this.widget.find('.media-empty__text'),
            placeholder = this.widget.find('.media-placeholder'),
            removeLink = this.widget.find('.media-remove-all'),
            footer = this.widget.find('.box__footer'),
            trashBtn = this.widget.find('.icon__trash'),
            compareBtn = this.widget.find('a.btn--compare-widget').add($(document).find('.compare--srp--mobile a.btn')),
            stickyMobile = $(document).find('.compare--srp--mobile');

        // fix page number if needed
        if (this.page !== 0 && (this.page * config.maxPerPage >= storageData.length)) {
            this.page--;
        }

        placeholder.addClass(config.hiddenClass);

        if (storageData.length === 0) {
            list.addClass(config.hiddenClass);
            emptyImage.removeClass(config.hiddenClass);
            emptyText.removeClass(config.hiddenClass);
            removeLink.addClass(config.hiddenClass);
            stickyMobile.addClass(config.hiddenStickyClass);
            trashBtn.addClass(config.hiddenClass);
        }  else {
            emptyImage.addClass(config.hiddenClass);
            emptyText.addClass(config.hiddenClass);
            removeLink.removeClass(config.hiddenClass);
            list.removeClass(config.hiddenClass).html('');
            stickyMobile.removeClass(config.hiddenStickyClass);
            trashBtn.removeClass(config.hiddenClass);
        }

        if (storageData.length === 1) {
            placeholder.removeClass(config.hiddenClass);
            emptyText.removeClass(config.hiddenClass);
        }

        if (storageData.length <= 1) {
            footer.addClass(config.hiddenClass);
            compareBtn.removeAttr('href').addClass(config.disabledClass);
        } else {
            footer.removeClass(config.hiddenClass);
            compareBtn.attr('href', config.btnHref + '?cnt=' + storageData.length).removeClass(config.disabledClass);
        }

        for (let i = this.page * config.maxPerPage; i < storageData.length; i++) {
            let el = this.itemTemplate.clone(true).removeAttr('style').removeAttr('id'),
                item = storageData[i];

            if (this.widget.find('.media-list .compare__item').length === config.maxPerPage) {
                continue;
            }

            el.attr('data-compare-id', item.id);
            el.find('.media__remove').attr('data-compare-remove', item.id);
            el.find('a').attr('href', item.url);
            el.find('.media__image').attr('src', item.image);
            el.find('.media__title__link').text(item.title);
            el.find('.media__price').text('€ ' + item.price);

            list.append(el);
        }
    }

    setPagination(items) {
        let pagination = this.widget.find('.compare__pagination');

        pagination.addClass(config.hiddenClass);

        if (items.length > config.maxPerPage) {
            // adding pages for each 4 items in array
            let pages = parseInt(items.length / config.maxPerPage) + ((items.length % config.maxPerPage) > 0 ? 1 : 0),
                list = pagination.find('.pagination__list');

            if (pages > 1) {
                list.html('');

                for (let i = 0; i < pages; i++) {
                    let pageEl = this.pageTemplate.clone(true).removeAttr('style').removeAttr('id');
                    pageEl.attr('data-page', i).find('a').text(i + 1);

                    if (i === this.page) {
                        pageEl.find('a').addClass('is--current');
                    }

                    pageEl.on('click', '', $.proxy(this, 'setPage'));
                    list.append(pageEl);
                }

                pagination.removeClass(config.hiddenClass);
            }
        }
    }

    setPage(e) {
        this.page = $(e.currentTarget).data('page');
        this.rebuild();

        return false;
    }

    getFromStorage() {
        try {
            return (JSON.parse(localStorage.compareItems) || [])
                .filter(ad =>  ad.sellerType == null || ad.sellerType === 2);
        } catch (e) {
            return [];
        }
    }

    setListeners() {
        $(document).on('compare:storage:change', $.proxy(this, 'rebuild'));
    }

    replace() {
        let items = this.getFromStorage();

        if (items.length) {
            $('[data-compare-replace]').addClass(config.hiddenClass);
            $('[data-compare-widget-box]').removeClass(config.hiddenClass);
        } else {
            $('[data-compare-replace]').removeClass(config.hiddenClass);
            $('[data-compare-widget-box]').addClass(config.hiddenClass);
        }
    }

    init() {
        this.replace();
        this.setListeners();
        this.rebuild();
    }
}
